<template>
    <img
        class="weather-widget__icon-image"
        :src="source"
        :alt="altText"
    >
</template>

<script setup>
const props = defineProps({
    condition: {
        type: String,
        required: true,
    },
})

// Determine which icon to load
const source = computed(() => {
    if (props.condition === 'sunny') {
        return '/images/weather/sunny.png'
    } else if (props.condition === 'sunny_cloudy') {
        return '/images/weather/sunny_cloudy.png'
    } else {
        return '/images/weather/cloudy.png'
    }
})

// Determine which alt text to load
const altText = computed(() => {
    if (props.condition === 'sunny') {
        return 'sunny icon'
    } else if (props.condition === 'sunny_cloudy') {
        return 'sunny and cloudy icon'
    } else {
        return 'cloudy icon'
    }
})
</script>
